// TooltipContext.tsx
import type React from "react";
import { createContext, useContext, useState } from "react";

const TooltipContext = createContext<{
	activeTooltip: string | null;
	setActiveTooltip: (id: string | null) => void;
}>({
	activeTooltip: null,
	setActiveTooltip: () => {},
});

export const TooltipProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [activeTooltip, setActiveTooltip] = useState<string | null>(null);

	return <TooltipContext.Provider value={{ activeTooltip, setActiveTooltip }}>{children}</TooltipContext.Provider>;
};

export const useTooltip = () => useContext(TooltipContext);
